"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiValidateLoginErrorResponse = instanceOfApiValidateLoginErrorResponse;
exports.ApiValidateLoginErrorResponseFromJSON = ApiValidateLoginErrorResponseFromJSON;
exports.ApiValidateLoginErrorResponseFromJSONTyped = ApiValidateLoginErrorResponseFromJSONTyped;
exports.ApiValidateLoginErrorResponseToJSON = ApiValidateLoginErrorResponseToJSON;
exports.ApiValidateLoginErrorResponseToJSONTyped = ApiValidateLoginErrorResponseToJSONTyped;
/**
 * Check if a given object implements the ApiValidateLoginErrorResponse interface.
 */
function instanceOfApiValidateLoginErrorResponse(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined)
        return false;
    return true;
}
function ApiValidateLoginErrorResponseFromJSON(json) {
    return ApiValidateLoginErrorResponseFromJSONTyped(json, false);
}
function ApiValidateLoginErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'status': json['status'],
        'message': json['message'],
        'errorCode': json['error_code'],
        'detail': json['detail'] == null ? undefined : json['detail'],
    };
}
function ApiValidateLoginErrorResponseToJSON(json) {
    return ApiValidateLoginErrorResponseToJSONTyped(json, false);
}
function ApiValidateLoginErrorResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'status': value['status'],
        'message': value['message'],
        'error_code': value['errorCode'],
        'detail': value['detail'],
    };
}
